import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { admin } from 'routes/route.map'

import BeneficiaryAddComponent from './component'

export const BeneficiaryAdd = combine(
  withContext(
    'adminBeneficiariesService',
    ServicesContext,
    ({ adminBeneficiariesService }) => adminBeneficiariesService
  ),

  withCallback(
    'onSubmit',
    ({ adminBeneficiariesService }, { history }) =>
      async (beneficiary) => {
        await adminBeneficiariesService.createBeneficiary(beneficiary)
        toaster.info('Beneficiary has been successfully created')
        history.push(admin.beneficiaries())
      },
    []
  )
)(BeneficiaryAddComponent)
